// default icon, symbols and images
import accumulatedVoltsSVG from './accumulated-volts.svg';
import addSVG from './add.svg';
import adminLogoPNG from './admin-logo.png';
import advertisingSVG from './advertising.svg';
import amexSVG from './amex.svg';
import arrowMobileSVG from './arrow-mobile.svg';
import assignChargeStationsSVG from './assign-charge-stations.svg';
import assingSVG from './assing.svg';
import associationRemoveSVG from './association-remove.svg';
import availableCreditSVG from './available-credit.svg';
import avatarSVG from './avatar.svg';
import backArrowBSVG from './back-arrow-b.svg';
import backArrowSVG from './back-arrow.svg';
import barcodeJPG from './barcode.jpg';
import bulkCreateSVG from './bulk-create.svg';
import chargeSessionsSVG from './charge-sessions.svg';
import chargingSVG from './charging.svg';
import checkRedSVG from './check-red.svg';
import checkSVG from './check.svg';
import checkGreenSVG from './checkgreen.svg';
import claimedVoltSVG from './claimed-volts.svg';
import closeBSVG from './close-b.svg';
import closeSVG from './close.svg';
import closingBalanceSVG from './closing-balance.svg';
import confirmationSVG from './confirmation.svg';
import creditcardBgPNG from './credit-card-bg.png';
import currentBalanceSVG from './current-balance.svg';
import changeVersion from './change-version.svg';
import dankortSVG from './dankort.svg';
import dashboardBtnSVG from './dashboard-btn.svg';
import dashboardSVG from './dashboard.svg';
import dataLoaderGIF from './data-loader.gif';
import deleteSVG from './delete.svg';
import dinersClubCrateBlancheSVG from './diners_club_carte_blanche.svg';
import disabledredSVG from './disabled-red.svg';
import disabledSVG from './disabled.svg';
import discoverSVG from './discover.svg';
import disputedSVG from './disputed.svg';
import downArrowSVG from './down-arrow.svg';
import downSVG from './down.svg';
import doenloadLocationsSVG from './download-locations.svg';
import driverGreySVG from './drivers-grey.svg';
import driversRSVG from './drivers-r.svg';
import driversSVG from './drivers.svg';
import dropdownMenuSVG from './dropdown-menu.svg';
import dropdownMenuVerticalSVG from './dropdown-menu_vertical.svg';
import duplicateSVG from './duplicate.svg';
import editSVG from './edit.svg';
import enable2FASVG from './enable-2FA.svg';
import enableSVG from './enable.svg';
import energySVG from './energy.svg';
import errorIconSVG from './error-icon.svg';
import expenseSVG from './expense.svg';
import expiredVoltsSVG from './expired-volts.svg';
import exportSVG from './export.svg';
import filterBSVG from './filter-b.svg';
import filterSVG from './filter.svg';
import flashSVG from './flash.svg';
import fleetSettingsSVG from './fleet-settings.svg';
import forwardSVG from './forward.svg';
import greyChargerPNG from './grey-charger.png';
import generateTokenSVG from './generate-token.svg';
import hasMenuArrowSVG from './has-menu-arrow.svg';
import help02SVG from './help-02.svg';
import helpSVG from './help.svg';
import help_rSVG from './help_r.svg';
import historySVG from './history.svg';
import icapprovalSVG from './ic-approval.svg';
import icassignpermissionSVG from './ic-assign-permission.svg';
import icassignSVG from './ic-assign.svg';
import icattachvatSVG from './ic-attach-vat.svg';
import iccopySVG from './ic-copy.svg';
import icdateSVG from './ic-date.svg';
import icdetailSVG from './ic-detail.svg';
import icdeviceSVG from './ic-device.svg';
import icdownloadSVG from './ic-download.svg';
import iceditSVG from './ic-edit.svg';
import icgenerateCDRSVG from './ic-generate-CDR.svg';
import icinformationSVG from './ic-information.svg';
import icrfidcardsSVG from './ic-rfid-cards.svg';
import icvideoSVG from './ic-video.svg';
import icvoltSVG from './ic-volt.svg';
import importSVG from './import.svg';
import infoiconSVG from './info-icon.svg';
import InstaVoltlogopinPNG from './InstaVolt-logo-pin.png';
import jcbSVG from './jcb.svg';
import laserSVG from './laser.svg';
import lockSVG from './lock.svg';
import loginbackgroundJPG from './login-background.jpg';
import loginbgshapes02SVG from './login-bg-shapes-02.svg';
import loginbgshapesSVG from './login-bg-shapes.svg';
import loginiconSVG from './login-icon.svg';
import logoPNG from './logo.png';
import logoutSVG from './logout.svg';
import logsgreySVG from './logs-grey.svg';
import maestroSVG from './maestro.svg';
import markerbigSVG from './marker_big.svg';
import mastercardSVG from './mastercard.svg';
import mastersSVG from './masters.svg';
import nodataPNG from './no-data.png';
import noimagefoundJPG from './no-image-found.jpg';
import nxtarlastSVG from './nxtar-last.svg';
import nxtarSVG from './nxtar.svg';
import organisationsSVG from './organisations.svg';
import organizationsactiveSVG from './organizations-active.svg';
import partial_paySVG from './partial_pay.svg';
import paymentSVG from './payment.svg';
import payment_graySVG from './payment_gray.svg';
import permissionwSVG from './permission-w.svg';
import permissionSVG from './permission.svg';
import pinPNG from './pin.png';
import playSVG from './play.svg';
import prevarfirstSVG from './prevar-first.svg';
import prevarSVG from './prevar.svg';
import processGIF from './process.gif';
import profileSVG from './profile.svg';
import promotionsSVG from './promotions.svg';
import promotionsgraySVG from './promotions_gray.svg';
import promotionsrSVG from './promotions_r.svg';
import refundSVG from './refund.svg';
import refundbSVG from './refund_b.svg';
import replaceSVG from './replace.svg';
import reseticonSVG from './reset-icon.svg';
import resetpasswordSVG from './reset-password.svg';
import rfidcardsgreySVG from './rfid-cards-grey.svg';
import rfidcardsredSVG from './rfid-cards-red.svg';
import rfidcardsSVG from './rfid-cards.svg';
import regenerateToken from './re-generate-token.svg';
import reHandshakeSVG from './re-handshake.svg';
import sendemailSVG from './send-email.svg';
import settingsgreySVG from './settings-grey.svg';
import settingsSVG from './settings.svg';
import sortingSVG from './sorting.svg';
import sortingascSVG from './sorting_asc.svg';
import sortingdescSVG from './sorting_desc.svg';
import stationsbSVG from './stations-b.svg';
import stationsSVG from './stations.svg';
import statuschangeredSVG from './status-change-red.svg';
import statuschangeSVG from './status-change.svg';
import subscriptionSVG from './subscription.svg';
import successiconSVG from './success-icon.svg';
import synchronizeSVG from './synchronize.svg';
import tagsbSVG from './tags-b.svg';
import tagsSVG from './tags.svg';
import tariffGreySVG from './tariff-grey.svg';
import transactionlogsSVG from './transaction-logs.svg';
import transactionsbSVG from './transactions-b.svg';
import transactionsSVG from './transactions.svg';
import uatpSVG from './uatp.svg';
import unbilledamountSVG from './unbilled-amount.svg';
import undoSVG from './undo.svg';
import unlockSVG from './unlock.svg';
import usersessionsSVG from './user-sessions.svg';
import usersSVG from './users.svg';
import vatSVG from './vat.svg';
import visaSVG from './visa.svg';
import visa_electronSVG from './visa_electron.svg';
import voltsliabilitySVG from './volts-liability.svg';
import warningIconSVG from './warning-icon.svg';
import rightArrowSVG from './right_arrow.svg';
import verifiedSVG from './Verified.svg';
import currencyConversionInfoPNG from './currencyConversionInfo.png';
import addNoteSVG from './add-note.svg';
import fakeAccountSVG from './fake-account.svg';
import notesIconSVG from './notes-icon.svg';
import cposSVG from './cpos.svg';
import dropDownArrowSVG from './drop-down-arrow.svg';
import financialDetailsSVG from './financial-details.svg';
import letterHistorySVG from './letter-history.svg';
import deleteRedSVG from './delete-red.svg';
import disableReferral from './disable-referral.svg';
import enableReferral from './enable-referral.svg';
import tariffSVG from './tariff.svg';
import paymentFailSVG from './payment-fail.svg';
import promotionsRedSVG from './promotions_r.svg';
import exportListSVG from './export-list.svg';
import claimRFIDCardReader from './claimRFIDCardReader.svg';
import cancelPendingTransactionSVG from './cancel-pending-transactions.svg';
//IS icon, symbol and images
import IS_accumulatedVoltsSVG from './regions/IS/accumulated-volts.svg';
import IS_assignChargeStationsSVG from './regions/IS/assign-charge-stations.svg';
import IS_assingSVG from './regions/IS/assing.svg';
import IS_associationRemoveSVG from './regions/IS/association-remove.svg';
import IS_availableCreditSVG from './regions/IS/available-credit.svg';
import IS_avatarSVG from './regions/IS/avatar.svg';
import IS_backArrowSVG from './regions/IS/back-arrow.svg';
import IS_bulkCreateSVG from './regions/IS/bulk-create.svg';
import IS_checkRedSVG from './regions/IS/check-red.svg';
import IS_claimedVoltSVG from './regions/IS/claimed-volts.svg';
import IS_closingBalanceSVG from './regions/IS/closing-balance.svg';
import IS_claimRFIDCardReader from './regions/IS/claimRFIDCardReader.svg';
import IS_confirmationSVG from './regions/IS/confirmation.svg';
import IS_currentBalanceSVG from './regions/IS/current-balance.svg';
import IS_dashboardBtnSVG from './regions/IS/dashboard-btn.svg';
import IS_disabledredSVG from './regions/IS/disabled-red.svg';
import IS_doenloadLocationsSVG from './regions/IS/download-locations.svg';
import IS_driversRSVG from './regions/IS/drivers-r.svg';
import IS_expiredVoltsSVG from './regions/IS/expired-volts.svg';
import IS_exportSVG from './regions/IS/export.svg';
import IS_flashSVG from './regions/IS/flash.svg';
import IS_help02SVG from './regions/IS/help-02.svg';
import IS_helpSVG from './regions/IS/help.svg';
import IS_help_rSVG from './regions/IS/help_r.svg';
import IS_importSVG from './regions/IS/import.svg';
import IS_loginbgshapesSVG from './regions/IS/login-bg-shapes.svg';
import IS_markerbigSVG from './regions/IS/marker_big.svg';
import IS_organizationsactiveSVG from './regions/IS/organizations-active.svg';
import IS_promotionsrSVG from './regions/IS/promotions_r.svg';
import IS_rfidcardsredSVG from './regions/IS/rfid-cards-red.svg';
import IS_statuschangeredSVG from './regions/IS/status-change-red.svg';
import IS_synchronizeSVG from './regions/IS/synchronize.svg';
import IS_unbilledamountSVG from './regions/IS/unbilled-amount.svg';
import IS_voltsliabilitySVG from './regions/IS/volts-liability.svg';
import IS_adminLogoPNG from './regions/IS/admin-logo.png';
import IS_logoPNG from './regions/IS/logo.png';
import IS_nodataPNG from './regions/IS/no-data.png';
import IS_InstaVoltlogopinPNG from './regions/IS/InstaVolt-logo-pin.png';
import IS_CurrencyConversionInfoPNG from './regions/IS/currencyConversionInfo.png';
import IS_TariffSVG from './regions/IS/tariff.svg';
import IS_ExportListSVG from './regions/IS/export-list.svg';
import IS_PaymentFailSVG from './regions/IS/payment-fail.svg';
import IS_PromotionsRedSVG from './regions/IS/promotions_r.svg';

//Default
let images = {
    accumulatedVoltsSVG,
    addSVG,
    adminLogoPNG,
    advertisingSVG,
    amexSVG,
    arrowMobileSVG,
    assignChargeStationsSVG,
    assingSVG,
    associationRemoveSVG,
    availableCreditSVG,
    avatarSVG,
    backArrowBSVG,
    backArrowSVG,
    barcodeJPG,
    bulkCreateSVG,
    chargeSessionsSVG,
    chargingSVG,
    checkRedSVG,
    checkSVG,
    checkGreenSVG,
    claimedVoltSVG,
    closeBSVG,
    closeSVG,
    closingBalanceSVG,
    claimRFIDCardReader,
    confirmationSVG,
    creditcardBgPNG,
    currentBalanceSVG,
    changeVersion,
    dankortSVG,
    dashboardBtnSVG,
    dashboardSVG,
    dataLoaderGIF,
    deleteSVG,
    dinersClubCrateBlancheSVG,
    disabledredSVG,
    disabledSVG,
    discoverSVG,
    disputedSVG,
    downArrowSVG,
    downSVG,
    doenloadLocationsSVG,
    driverGreySVG,
    driversRSVG,
    driversSVG,
    dropdownMenuSVG,
    dropdownMenuVerticalSVG,
    duplicateSVG,
    editSVG,
    enable2FASVG,
    enableSVG,
    energySVG,
    errorIconSVG,
    expenseSVG,
    expiredVoltsSVG,
    exportSVG,
    filterBSVG,
    filterSVG,
    flashSVG,
    fleetSettingsSVG,
    forwardSVG,
    greyChargerPNG,
    generateTokenSVG,
    hasMenuArrowSVG,
    help02SVG,
    helpSVG,
    help_rSVG,
    historySVG,
    icapprovalSVG,
    icassignpermissionSVG,
    icassignSVG,
    icattachvatSVG,
    iccopySVG,
    icdateSVG,
    icdetailSVG,
    icdeviceSVG,
    icdownloadSVG,
    iceditSVG,
    icgenerateCDRSVG,
    icinformationSVG,
    icrfidcardsSVG,
    icvideoSVG,
    icvoltSVG,
    importSVG,
    infoiconSVG,
    InstaVoltlogopinPNG,
    jcbSVG,
    laserSVG,
    lockSVG,
    loginbackgroundJPG,
    loginbgshapes02SVG,
    loginbgshapesSVG,
    loginiconSVG,
    logoPNG,
    logoutSVG,
    logsgreySVG,
    maestroSVG,
    markerbigSVG,
    mastercardSVG,
    mastersSVG,
    nodataPNG,
    noimagefoundJPG,
    nxtarlastSVG,
    nxtarSVG,
    organisationsSVG,
    organizationsactiveSVG,
    partial_paySVG,
    paymentSVG,
    payment_graySVG,
    permissionwSVG,
    permissionSVG,
    pinPNG,
    playSVG,
    prevarfirstSVG,
    prevarSVG,
    processGIF,
    profileSVG,
    promotionsSVG,
    promotionsgraySVG,
    promotionsrSVG,
    refundSVG,
    refundbSVG,
    replaceSVG,
    reseticonSVG,
    resetpasswordSVG,
    rfidcardsgreySVG,
    rfidcardsredSVG,
    rfidcardsSVG,
    regenerateToken,
    reHandshakeSVG,
    sendemailSVG,
    settingsgreySVG,
    settingsSVG,
    sortingSVG,
    sortingascSVG,
    sortingdescSVG,
    stationsbSVG,
    stationsSVG,
    statuschangeredSVG,
    statuschangeSVG,
    subscriptionSVG,
    successiconSVG,
    synchronizeSVG,
    tagsbSVG,
    tagsSVG,
    tariffGreySVG,
    transactionlogsSVG,
    transactionsbSVG,
    transactionsSVG,
    uatpSVG,
    unbilledamountSVG,
    undoSVG,
    unlockSVG,
    usersessionsSVG,
    usersSVG,
    vatSVG,
    visaSVG,
    visa_electronSVG,
    voltsliabilitySVG,
    warningIconSVG,
    rightArrowSVG,
    verifiedSVG,
    currencyConversionInfoPNG,
    addNoteSVG,
    fakeAccountSVG,
    notesIconSVG,
    cposSVG,
    dropDownArrowSVG,
    financialDetailsSVG,
    letterHistorySVG,
    deleteRedSVG,
    disableReferral,
    enableReferral,
    tariffSVG,
    paymentFailSVG,
    promotionsRedSVG,
    exportListSVG,
    cancelPendingTransactionSVG,
};

// IS
let imagesFromIS = {
    ...images,
    accumulatedVoltsSVG: IS_accumulatedVoltsSVG,
    adminLogoPNG: IS_adminLogoPNG,
    assignChargeStationsSVG: IS_assignChargeStationsSVG,
    assingSVG: IS_assingSVG,
    associationRemoveSVG: IS_associationRemoveSVG,
    availableCreditSVG: IS_availableCreditSVG,
    avatarSVG: IS_avatarSVG,
    backArrowSVG: IS_backArrowSVG,
    bulkCreateSVG: IS_bulkCreateSVG,
    checkRedSVG: IS_checkRedSVG,
    claimedVoltSVG: IS_claimedVoltSVG,
    claimRFIDCardReader: IS_claimRFIDCardReader,
    closingBalanceSVG: IS_closingBalanceSVG,
    confirmationSVG: IS_confirmationSVG,
    currentBalanceSVG: IS_currentBalanceSVG,
    dashboardBtnSVG: IS_dashboardBtnSVG,
    disabledredSVG: IS_disabledredSVG,
    doenloadLocationsSVG: IS_doenloadLocationsSVG,
    driversRSVG: IS_driversRSVG,
    expiredVoltsSVG: IS_expiredVoltsSVG,
    exportSVG: IS_exportSVG,
    flashSVG: IS_flashSVG,
    help02SVG: IS_help02SVG,
    helpSVG: IS_helpSVG,
    help_rSVG: IS_help_rSVG,
    importSVG: IS_importSVG,
    loginbgshapesSVG: IS_loginbgshapesSVG,
    logoPNG: IS_logoPNG,
    markerbigSVG: IS_markerbigSVG,
    nodataPNG: IS_nodataPNG,
    organizationsactiveSVG: IS_organizationsactiveSVG,
    promotionsrSVG: IS_promotionsrSVG,
    rfidcardsredSVG: IS_rfidcardsredSVG,
    statuschangeredSVG: IS_statuschangeredSVG,
    synchronizeSVG: IS_synchronizeSVG,
    unbilledamountSVG: IS_unbilledamountSVG,
    voltsliabilitySVG: IS_voltsliabilitySVG,
    InstaVoltlogopinPNG: IS_InstaVoltlogopinPNG,
    currencyConversionInfoPNG: IS_CurrencyConversionInfoPNG,
    tariffSVG: IS_TariffSVG,
    exportListSVG: IS_ExportListSVG,
    paymentFailSVG: IS_PaymentFailSVG,
    promotionsRedSVG: IS_PromotionsRedSVG,
};

//UK
let defaultImages = {
    ...images,
};

if (process.env.REACT_APP_PORTAL_REGION === 'IS') {
    images = defaultImages;
} else if (process.env.REACT_APP_PORTAL_REGION === 'UK') {
    images = defaultImages;
} else if (process.env.REACT_APP_PORTAL_REGION === 'ES') {
    images = defaultImages;
} else if (process.env.REACT_APP_PORTAL_REGION === 'IE') {
    images = defaultImages;
} else if (process.env.REACT_APP_PORTAL_REGION === 'PT') {
    images = defaultImages;
} else if (process.env.REACT_APP_PORTAL_REGION === 'REGION') {
    //To be removed later
    images = imagesFromIS;
}

export default images;
